/**
 * שרטוט שלא נטען — ניסיון אחד נוסף אחרי 3 שניות, לכל המסכים בבת אחת.
 *
 * אלי 18/10/2026 („למה לא כל התמונות עולות?"): עמדה שקיבלה 429 נשארה עם
 * כרטיס ריק עד רענון. ה-onError של המסכים מסתיר את התמונה (`display:none`);
 * כאן מחזירים אותה ומבקשים שוב — פעם אחת בלבד (`&retry=1`), כדי שקובץ שבאמת
 * חסר (404) לא ייבקש בלולאה. מאזין אחד ב-capture, כי `error` של תמונה לא מבעבע.
 */
const THUMB = '/api/scan/station/thumb';

export function installThumbRetry(doc: Document = document, delayMs = 3000): () => void {
  const onError = (e: Event): void => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement)) return;
    const src = img.getAttribute('src') ?? '';
    if (!src.includes(THUMB) || src.includes('retry=1')) return;
    setTimeout(() => {
      if (!img.isConnected || img.getAttribute('src') !== src) return; // המסך כבר החליף אותה
      img.style.display = '';
      img.setAttribute('src', `${src}&retry=1`);
    }, delayMs);
  };
  doc.addEventListener('error', onError, true);
  return () => doc.removeEventListener('error', onError, true);
}
